<template>
  <div class="edit-style-slider">
    <label class="common-label">{{ labelText }}<span class="slider-value">{{ sliderValue }}</span></label>
    <input
      type="range"
      v-model="sliderValue"
      :step="step"
      :min="minValue"
      :max="maxValue"
      @change="updateSliderValue($event.target.value)"
    >
  </div>
</template>

<script>
export default {
  props: [
    'prop',
    'value',
  ],
  data () {
    return {
      labelText: null,
      sliderValue: 0,
      minValue: 0,
      maxValue: 25,
      step: 1
    }
  },
  methods: {
    initComponent () {
      this.initLabelText()
      this.initMinAndMaxValue()
      this.initSliderValue()
      this.setStep()
    },
    initLabelText () {
      if (!this.prop) return null
      switch (this.prop) {
        case 'padding-top':
          this.labelText = '上下の余白'
          break
        case 'padding-right':
          this.labelText = '左右の余白'
          break
        case 'inner-padding':
          this.labelText = '内側の余白'
          break
        case 'section_padding-top':
          this.labelText = '上下の余白'
          break
        case 'section_inner_padding-top':
          this.labelText = '上下の余白'
          break
        case 'image-card-padding':
          this.labelText = '内側の余白'
          break
        case 'spacer-width':
          this.labelText = '間隔の調整'
          break
      }
    },
    initSliderValue () {
      this.sliderValue = this.value ? Number(this.value.replace(/px/g, '')) : 0
    },
    initMinAndMaxValue () {
      if (!this.prop) return null
      this.minValue = 0
      switch (this.prop) {
        case 'padding-top':
          this.maxValue = 20
          break
        case 'padding-right':
          this.maxValue = 20
          break
        case 'inner-padding':
          this.maxValue = 20
          break
        case 'section_padding-top':
          this.maxValue = 200
          break
        case 'section_inner_padding-top':
          this.maxValue = 200
          break
        case 'image-card-padding':
          this.maxValue = 10
          break
        case 'spacer-width':
          this.maxValue = 10
          break
      }
    },
    setStep () {
      if (this.prop === 'spacer-width') this.step = 2
    },
    trimValue (value) {
      if (!this.prop) return
      let trimValue = null
      const updateValue = value + 'px'
      switch (this.prop) {
        case 'padding-top':
          trimValue = [
            { prop: 'padding-top', value: updateValue },
            { prop: 'padding-bottom', value: updateValue }
          ]
          break
        case 'padding-right':
          trimValue = [
            { prop: 'padding-right', value: updateValue },
            { prop: 'padding-left', value: updateValue }
          ]
          break
        case 'inner-padding':
          trimValue = [
            { prop: 'inner-padding', value: updateValue }
          ]
          break
        case 'section_padding-top':
          trimValue = [
            { prop: 'padding-top', value: updateValue },
            { prop: 'padding-bottom', value: updateValue }
          ]
          break
        case 'section_inner_padding-top':
          trimValue = [
            { prop: 'inner_padding-top', value: updateValue },
            { prop: 'inner_padding-bottom', value: updateValue }
          ]
          break
        case 'image-card-padding':
          trimValue = updateValue
          break
        case 'spacer-width':
          trimValue = updateValue
          break
      }
      return trimValue
    },
    updateSliderValue (value) {
      const updateValue = this.trimValue(value)
      this.$emit('updateStyles', updateValue)
    }
  },
  beforeMount () {
    this.initComponent()
  },
  watch: {
    value () {
      this.initSliderValue()
    },
    // prop が変更されたら、コンポーネント初期化
    prop () {
      this.initComponent()
    },
  }
}
</script>

<style lang="scss" scoped>
.edit-style-slider {
  .common-label {
    margin-bottom: 10px;
    .slider-value {
      display: inline-block;
      margin-left: 20px;
      width: 40px;
      height: 18px;
      line-height: 18px;
      border-radius: 15px;
      text-align: center;
      background: #fff;
    }
  }
  input[type="range"] {
    width: 300px;
  }
}
</style>
